<template>
  <div class="feature-icon-list">
    <div class="row align-items-center">
      <div class="col-lg-6 feature-visual-column">
        <div class="feature-icon-list__media">
          <img
            src="../assets/img/banners/mockup.png"
            class="img-fluid"
            width="815" height="550" loading="lazy" decoding="async"
            alt="Illustration of the MoDeck browser editor on desktop and mobile"
          />
        </div>
      </div>
      <div class="col-lg-6">
        <div class="feature-icon-list__content">
          <div class="feature-icon-list-wrapper">
            <div v-for="feature in features" :key="feature.id" class="single-feature-icon">
              <div class="single-feature-icon__media">
                <i class="fal feature-icon" :class="feature.icon"></i>
              </div>
              <div class="single-feature-icon__content">
                <h3 class="title">{{ feature.title }}</h3>
                <p class="text">{{ feature.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "featureList",
  data() {
    return {
      features: [
        {
          icon: "fa-sliders-h",
          title: "You choose what can change",
          desc:
            "Expose only the text, media, colors, numbers, and choices needed for the job.",
        },
        {
          icon: "fa-file-video",
          title: "Your team works in a browser",
          desc:
            "Editors make safe, on-brand versions without After Effects or access to the project file.",
        },
        {
          icon: "fa-desktop",
          title: "Rendering stays on your machine",
          desc:
            "The desktop app sends approved versions through your own After Effects and Media Encoder setup.",
        },
      ],
    };
  },
};
</script>


<style scoped>
.feature-icon-list {
  max-width: 1500px;
  margin: 0 auto;
}

.feature-visual-column {
  padding-right: clamp(20px, 4vw, 70px);
}

.feature-icon-list__media {
  max-width: 720px;
  margin-left: auto;
}

.feature-icon-list-wrapper .single-feature-icon {
  padding: 24px 28px;
  border: 1px solid #edf0f5;
  box-shadow: none;
}

.feature-icon-list-wrapper .single-feature-icon:nth-child(2n) {
  margin-left: 0;
}

.feature-icon-list-wrapper .single-feature-icon:hover {
  border-color: rgba(104, 192, 206, 0.5);
  box-shadow: 0 14px 36px rgba(54, 69, 99, 0.08);
}

.feature-icon {
  font-size: 28px;
  background: #ee408b;
  color: rgb(255, 255, 255);
  padding: 14px 0;
  border-radius: 10px;
  margin: 20px 0 0;
  width: 58px;
  text-align: center;
  display: inline-block;
}

.single-feature-icon__content .title {
  font-size: 18px;
  line-height: 1.45;
}

.single-feature-icon__content .text {
  margin-bottom: 0;
  line-height: 1.8;
}

@media (max-width: 991px) {
  .feature-visual-column {
    padding-right: 12px;
  }
}

@media (max-width: 575px) {
  .feature-icon-list-wrapper .single-feature-icon {
    padding: 25px 22px;
  }
}
</style>
